export function shortenString(string: string, length: number) {
  if (!string || !length) return string;
  if (string.length > length) {
    return string.substring(0, length - 1) + "...";
  } else {
    return string;
  }
}
